import { CuratedStory, Story } from "../../contracts/Story";
import {
  stringForSingleLineComponentWithId,
  paragraphsForParagraphCollectionComponentWithId,
  flattenRichText,
} from "../../mapper/api-mappers";
import { DataMapper, DataMapperInterface } from "..";
import { Page } from "~/use-cases/contracts/Page";

export default (data: any): Page => {
  const mapper = DataMapper();
  return documentToPage(mapper, data);
};

const documentToPage = (mapper: DataMapperInterface, data: any): Page => {
  const content = paragraphsForParagraphCollectionComponentWithId(
    data.components,
    "content",
  );
  const accordion = paragraphsForParagraphCollectionComponentWithId(
    data.components,
    "accordion",
  );

  const dto: Page = {
    path: data.path,
    name: data.name,
    title:
      stringForSingleLineComponentWithId(data.components, "title") ||
      data.name!,
    content:
      content?.map((paragraph) => {
        return {
          title: paragraph.title?.text || "",
          body: flattenRichText(paragraph.body),
          images: mapper.API.Object.APIImageToImage(paragraph.images),
        };
      }) || [],
    accordion:
      accordion?.map((paragraph) => {
        return {
          title: paragraph.title?.text || "",
          body: flattenRichText(paragraph.body),
          images: mapper.API.Object.APIImageToImage(paragraph.images),
        };
      }) || [],
  };
  return dto;
};
